import { render } from "./Card.vue?vue&type=template&id=311f562a"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=311f562a&lang=css"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__